import template from './unauthenticated-footer.component.html';
import controller from './unauthenticated-footer.controller';

const unauthenticatedFooter = {
  template,
  controller,
};

export default unauthenticatedFooter;
